import { Link } from '@tanstack/react-router';
import { cn } from '@/lib/cn';
import { Icon, buttonVariants } from '@/ui/common';

export interface ClaimBonusSuccessProps {
  label: (key: string, fallback: string) => string;
  className?: string;
}

/** Thank-you state after a successful lost-bonus claim (legacy modern). */
export function ClaimBonusSuccess({ label, className }: ClaimBonusSuccessProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center gap-4 rounded-md bg-bg-elevated px-5 py-10 text-center',
        className,
      )}
    >
      <Icon name="bonus-gift" size={48} className="text-status-success" />
      <p className="text-[18px] font-bold text-text-primary">
        {label('BonusSuccessfullyReceived!', 'Bonus Successfully Received!')}
      </p>
      <Link
        to="/"
        className={cn(
          buttonVariants({ variant: 'primary', size: 'lg', fullWidth: true }),
          'max-w-sm',
        )}
      >
        {label('PlayNow', 'Play Now!')}
      </Link>
      <div className="flex w-full max-w-sm gap-2">
        <Link
          to="/live"
          search={{ sport: undefined, tournament: undefined, media: undefined }}
          className={cn(
            buttonVariants({ variant: 'secondary', size: 'md', fullWidth: true }),
            'gap-2',
          )}
        >
          <Icon name="live-icon" size={16} />
          {label('LiveBets', 'Live Bets')}
        </Link>
        <Link
          to="/casino"
          className={cn(
            buttonVariants({ variant: 'secondary', size: 'md', fullWidth: true }),
            'gap-2',
          )}
        >
          <Icon name="casino" size={16} />
          {label('Casino', 'Casino')}
        </Link>
      </div>
    </div>
  );
}
